<template>
  <Modal :id="'cmp-customer_feedback'" @cancelled="onCancel">
    <template slot="header"> {{$t('feedback_title')}} </template>

    <template slot="body">
      <div class="form-group">
        <!-- <div style="max-width: 320px">
          <TextField
            class="m1"
            :id="'cc_email'"
            required
            :validators="emailValidators"
            v-bind="textFieldConfig"
            :value="feedback.cc_email"
            :placeholder="'CC'"
            @valuechanged="onTextFieldValueChange"
            @validated="onFeedbackValidation"
          ></TextField>
        </div> -->
        <TextField
          class="m1"
          :id="'description'"
          required
          textarea
          v-bind="textFieldConfig"
          :height="120"
          :value="feedback.description"
          :placeholder="$t('feedback_text')"
          @valuechanged="onTextFieldValueChange"
          @validated="onFeedbackValidation"
        ></TextField>
        <div style="max-width: 320px">
          <Dropdown
            :options="priorities"
            class="m2"
            :selected="priorities.find((e) => e.value === feedback.severity)"
            :placeholder="$t('feedback_priority')"
            v-on:selectedChange="(e) => onDropdownChange('severity', e)"
            :listHeight="120"
            box
          ></Dropdown>
        </div>
      </div>
      <FileUploaderUI
        :subtitle="$t('feedback_upload')"
        image
        @files="onFileUploaderEmitted"
      />
      <div
        class="ut-flex metadata-container"
        style="background: var(--bc-3); padding: 8px; margin-top: 12px"
      >
        <!-- <div class="ut-fc">
        Module: CatalogProducts
        Route: /catalog/products
        Link: https://www.example.com/catalog/products
        Report Time: 2019-01-01 00:00:00
        UTC: 2019-01-01 00:00:00
      </div>
      
      <div class="ut-fc">
        User Agent: Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:64.0) Gecko/20100101 Firefox/64.0
        Browser Name: Firefox
        Browser Version: 64.0
        Operating System: Windows 10
        Screen Info: 1920x1080
        Zone: America/New_York
      </div>

      <div class="ut-fc">
        Username: johnsmith
        Name: John Smith
        Email:
        Company: Example Company
        Address: 123 Example Street
        Database: MySQL
      </div> -->
        <table class="kv-table ut-text-5">
          <tr>
            <td class="kv-table--title">Device Info</td>
          </tr>
          <tr>
            <td>Browser Name</td>
            <td>
              {{ feedback.json_data.browser_name }}
            </td>
          </tr>
          <tr>
            <td>Browser Version</td>
            <td>
              {{ feedback.json_data.browser_version }}
            </td>
          </tr>
          <!-- <tr>
            <td>User Agent</td>
            <td>
              Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:64.0) Gecko/20100101
              Firefox/64.0
            </td>
          </tr> -->
          <tr>
            <td>Operating System</td>
            <td>
              {{ feedback.json_data.operating_system }}
            </td>
          </tr>
          <tr>
            <td>Screen Info</td>
            <td>
              {{ feedback.json_data.screen_info }}
            </td>
          </tr>
          <tr>
            <td>Zone</td>
            <td>
              {{ feedback.json_data.zone }}
            </td>
          </tr>
          <tr>
            <td>Locale</td>
            <td>
              {{ feedback.json_data.locale }}
            </td>
          </tr>
          <!-- </table>

        <table class="cur-kv"> -->
          <tr>
            <td class="kv-table--title">App Info</td>
          </tr>
          <tr>
            <td>Module</td>
            <td>{{ feedback.json_data.module }}</td>
          </tr>
          <tr>
            <td>Route</td>
            <td>{{ feedback.json_data.route }}</td>
          </tr>
          <tr>
            <td>Link</td>
            <td>{{ feedback.json_data.link }}</td>
          </tr>
          <tr>
            <td>Report Time</td>
            <td>
              {{ new Date(feedback.reported_at).toLocaleString() }}
            </td>
          </tr>
          <tr>
            <td>UTC</td>
            <td>
              {{ feedback.json_data.utc }}
            </td>
          </tr>
          <tr>
            <td>Language</td>
            <td>
              {{ feedback.json_data.language }}
            </td>
          </tr>
          <!-- </table>

        <table class="cur-kv"> -->
          <tr>
            <td class="kv-table--title">User Info</td>
          </tr>
          <tr>
            <td>Username</td>
            <td>
              {{ feedback.json_data.username }}
            </td>
          </tr>
          <tr>
            <td>Name</td>
            <td>
              {{ feedback.json_data.name }}
            </td>
          </tr>
          <tr>
            <td>Email</td>
            <td>
              {{ feedback.json_data.email }}
            </td>
          </tr>
          <tr>
            <td>Company</td>
            <td>
              {{ feedback.json_data.company }}
            </td>
          </tr>
          <tr>
            <td>Address</td>
            <td>
              {{ feedback.json_data.address }}
            </td>
          </tr>
        </table>
      </div>
      <div class="ut-flex ut-mt-12px" style="align-items: flex-start">
        <div class="ut-fc">
          <DTCheckbox
            :id="'barcode_catalog_error'"
            :label="''"
            :checked="agreeFlag"
            @click="onAgree"
            :minH="'0px'"
            style="height: 16px"
            :class="'ml0'"
          />
        </div>
        <span class="ut-ml-4px ut-text-secondary">
          {{$t('feedback_agree')}}
          <img
            class="dt-icon s1"
            :title="agreeText"
            src="static/icons/question.svg"
            alt=""
          />
        </span>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click="onCancel"> {{$t('cancel')}} </button>
      <button
        class="dt-button v1 s6"
        :disabled="
          !agreeFlag ||
          submitFlag ||
          Object.values(feedbackValidation).some((e) => e.valid === false)
        "
        :class="{
          disabled:
            !agreeFlag ||
            submitFlag ||
            Object.values(feedbackValidation).some((e) => e.valid === false),
        }"
        @click="onSubmit"
      >
        {{$t('submit')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/dt-plugins/modal/modal";
import DTCheckbox from "../../../plugins/checkbox/checkbox";
import { getDeviceInfo, getUTCTimeOffset } from "../../../utility";
import FileUploaderUI from "../../../dt-plugins/file-uploader/file-uploader-ui";
import isEmail from "validator/lib/isEmail";

import { FeedbackService } from "../../../services/feedback.service";
import { createValidator } from '../../../plugins/text-field';

export default {
  components: {
    Modal,
    DTCheckbox,
    FileUploaderUI,
  },
  props: {},

  mounted: async function () {},
  data: function () {
    return {
      emailValidators: [
        createValidator({
          name: "emailValidation",
          validatorFn: isEmail,
          errorMessage: "Must be a valid Email"
        })
      ],
      feedbackValidation: {},
      agreeText: `
At Details, we value the input of our users and strive to provide a seamless experience by promptly addressing and resolving any technical issuess. When you submit a bug report, we collect certain technical information about your device and browser to aid our bug-fixing process. The data collected includes:

Browser Name: The name of your web browser.
Browser Version: The version of your web browser.
Operating System: The operating system running on your device.
Screen Information: Details about your device's screen resolution.
Time Zone: Your device's time zone.
Locale: Your preferred language and regional settings.

Please rest assured that the information collected is solely used for bug identification, debugging, and resolution purposes. We treat this data with the utmost confidentiality and adhere to strict data protection standards.

This data is crucial in helping us replicate and address reported issues accurately, leading to more effective bug fixes and an improved user experience for all our valued users.

By submitting a bug report, you acknowledge and consent to the collection and use of this technical information as described in this disclaimer.

If you have any concerns about the data collection process or require further information about how we handle user data, please refer to our Privacy Policy or contact our support team.

Thank you for contributing to the enhancement of Details App by providing valuable bug reports.


      `,
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
      },
      submitFlag: false,
      // An object of Bug/Feature/Performance Issue

      // Window Info
      // Module: ${this.$route.name}
      // Route: ${this.$route.fullPath}
      // Link: ${window.location.href}
      // Report Time: ${format(new Date(), "YYYY-MM-DD hh:mm:ss a")}
      // UTC: ${getUTCTimeOffset()}

      // Device Info
      // User Agent: ${userAgent}
      // Browser Name: ${browserName}
      // Browser Version: ${browserVersion}
      // Operating System: ${operatingSystem}
      // Screen Info: ${screenInfo}
      // Zone: ${Intl.DateTimeFormat().resolvedOptions().timeZone}

      // From
      // Username: ${this.$store.getters.account.user.user_name}
      // Name: ${this.$store.getters.account.user.staff_fullname}
      // Email: ${this.$store.getters.account.user.staff_email}
      // Company: ${this.$store?.getters?.account?.client?.client_name}
      // Address: ${this.$store?.getters?.account?.client?.client_address}
      // Database: ${this.$store?.getters?.account?.client?.clientID}
      feedback: this.getDefaultFeedback(),
      agreeFlag: true,
      priorities: [
        { text: "Low", value: 1 },
        { text: "Medium", value: 2 },
        { text: "High", value: 3 },
      ],
    };
  },
  methods: {
    getDefaultFeedback: function () {
      const {
        userAgent,
        browserName,
        browserVersion,
        operatingSystem,
        screenInfo,
      } = getDeviceInfo();

      return {
        // feedback_id: null,
        clientID: this.$store?.getters?.account?.client?.clientID,
        user_id: this.$store?.getters?.account?.user?.user_id,
        cc_email: this.$store?.getters?.account?.user?.staff_email,
        type: "bug_report",
        status: "open",
        priority: 2,
        severity: 2,
        project: "V2",
        title: `Bug Report From ${this.$store?.getters?.account?.client?.client_name} - ${this.$route.name}`,
        description: "",

        assigned_to: "",
        reported_by: "",
        related_to: "",

        file_name: null,

        json_data: {
          // App Info
          module: this.$route.name,
          route: this.$route.fullPath,
          link: window.location.href,
          utc: getUTCTimeOffset(),
          language: this.$store.getters.systemLanguage?.text,

          // Device
          user_agent: userAgent,
          browser_name: browserName,
          browser_version: browserVersion,
          operating_system: operatingSystem,
          screen_info: screenInfo,
          zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          locale: Intl.DateTimeFormat().resolvedOptions().locale,

          // From
          username: this.$store.getters.account.user.user_name,
          name: this.$store.getters.account.user.staff_fullname,
          email: this.$store.getters.account.user.staff_email,
          company: this.$store?.getters?.account?.client?.client_name,
          address: this.$store?.getters?.account?.client?.client_address,

          //version
          version: this.$store?.getters?.account?.version?.version,
          version_date: this.$store?.getters?.account?.version?.version_date,
          version_build_no:
            this.$store?.getters?.account?.version?.version_build_no,
        },
        created_at: new Date().toISOString(),
        reported_at: new Date().toISOString(),
        modified_at: new Date().toISOString(),
        assigned_at: new Date().toISOString(),
        target_date: new Date().toISOString(),
        fixed_in: new Date().toISOString(),
      };
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function (key, value) {
      this.feedback[key] = value;
    },
    onFeedbackValidation(name, value) {
      this.$set(this.feedbackValidation, name, value);
    },
    onAgree(e) {
      this.agreeFlag = !this.agreeFlag;
    },
    onDropdownChange: function (name, value) {
      this.feedback[name] = value.value;
    },
    async onSubmit() {
      const formData = new FormData();

      formData.append("action", "save");
      // formData.append("json_data", JSON.stringify(this.feedback.json_data));

      // Append all data of Feedback to formData
      Object.keys(this.feedback).forEach((key) => {
        if (key == "json_data") {
          formData.append(key, JSON.stringify(this.feedback.json_data));
        } else if (key == "file_name") {
          formData.append("file_name", this.feedback.file_name);
        } else {
          formData.append(key, this.feedback[key]);
        }
      });

      // console.log({ "customer-feedback.vue:404 formData": formData, });

      // const feedbackSumitted = await FeedbackService.submitFeedback(formData);
      this.submitFlag = true;
      const feedbackSumitted = await FeedbackService.submitFeedback(formData);
      this.submitFlag = false;
      console.log({
        "customer-feedback.vue:404 feedbackSumitted": feedbackSumitted,
      });
      this.$emit("submitted", true);
    },
    onFileUploaderEmitted(files) {
      this.feedback.file_name = files?.length > 0 ? files[0] : null;

      console.log({ Feedback: this.feedback, files });
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-customer_feedback {
  .metadata-container {
    flex-wrap: wrap;
    max-height: 200px;
    font-size: 12px;
    overflow: scroll;
    table {
      // max-width: 200px;
      tr {
        height: 22px;
      }
    }
  }
}
</style>
